import {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  applyAppUpdate,
  getPendingAppUpdate,
  subscribeToAppUpdate,
} from "../../utils/appServiceWorker";

export function useAppUpdate() {
  const [update, setUpdate] = useState(() =>
    getPendingAppUpdate()
  );
  const [dismissedWorker, setDismissedWorker] =
    useState(null);
  const [isApplying, setIsApplying] = useState(false);

  useEffect(() => {
    return subscribeToAppUpdate((nextUpdate) => {
      setUpdate(nextUpdate);
      setIsApplying(false);
    });
  }, []);

  const isUpdateAvailable = Boolean(update?.worker);

  const isVisible = useMemo(() => {
    return Boolean(
      update?.worker && update.worker !== dismissedWorker
    );
  }, [dismissedWorker, update]);

  const dismiss = useCallback(() => {
    if (update?.worker) {
      setDismissedWorker(update.worker);
    }
  }, [update]);

  const requestUpdate = useCallback(async () => {
    if (!update?.worker || isApplying) {
      return false;
    }

    setIsApplying(true);

    const didActivate = await applyAppUpdate(update);

    if (!didActivate) {
      setIsApplying(false);
    }

    return didActivate;
  }, [isApplying, update]);

  return {
    dismiss,
    isApplying,
    isUpdateAvailable,
    isVisible,
    requestUpdate,
    version: update?.version || null,
  };
}
